<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <p-inputMask
    class="{{
      formControl.invalid && formControl.touched ? 'p-invalid' : ''
    }} {{ !!formControl.value ? 'p-filled' : '' }}"
    [id]="field.id"
    [placeholder]="props.placeholder"
    type="tel"
    mask="(***) ***-****"
    slotChar="0000000000"
    characterPattern="[0-9]"
    [unmask]="true"
    [readonly]="props.readonly"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (onComplete)="props.onComplete && props.onComplete(field, $event)"
    (onFocus)="props.onFocus && props.onFocus(field, $event)"
    (onBlur)="props.onBlur && props.onBlur(field, $event)"
    (onInput)="props.onInput && props.onInput(field, $event)"
    (onKeydown)="props.onKeydown && props.onKeydown(field, $event)"
    (onClear)="props.onClear && props.onClear(field, $event)"
  ></p-inputMask>
</span>
